import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { enums } from '../../../constants'
import storage from '../../../services/stoage.service'
import utils, { getMessage } from '../../../utils'
import { actions } from '../transrecenciaentrecontas.actions'
import { Button } from 'primereact/button'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { logarAcesso } from '../../../services/api-log-acesso'
import { TransferenciaEntreContasForm } from './TransferenciaEntreContasForm'

const mapStateToProps = (state) => {
  const messages = state.crudTransferenciaEntreContasState.messages
  const record = state.crudTransferenciaEntreContasState.currentRecord

  // REFERENTE AO DROPDOWN DE UNIDADES
  let disableUnit = false
  let currentUnit = storage.getUnit()
  if (currentUnit) {
    let unidade = {
      id: currentUnit.oid,
      value: currentUnit.sigla,
    }
    Object.assign(record, { unidades: [unidade] })
    Object.assign(record, { unidadeSelecionada: unidade })
    disableUnit = true
  }

  const currentCompany = storage.getCompany()
  let unidades = []
  let unidadesEmpresa = utils.getListIdValuesUnidadeFromEmpresa(currentCompany)
  unidades = unidades.concat(unidadesEmpresa)

  return {
    currentCompany,
    record,
    messages,
    selectedFilters: state.crudTransferenciaEntreContasState.selectedFilters,
    unidades,
    disableUnit,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    newHandler: (event) => dispatch(actions.makeNew()),
    transferir: () => dispatch(actions.transferir()),
    clearSelectedFilters: () => dispatch(actions.clearSelectedFilters()),
  }
}

class TransferenciaEntreContasFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    logarAcesso().then()
    this.props.newHandler()
  }

  componentWillUnmount() {}

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  getCustomButtons = () => {
    return (
      <div className="p-toolbar-group-left">
        <Button
          label={utils.getMessage(this.props.messages, 'transferenciaentrecontas.label.transferir')}
          icon="pi pi-check"
          className="p-button-success"
          onClick={this.props.transferir}
        />
      </div>
    )
  }

  onChangeUnidade = (name, event) => {
    const unidadeOrigem = 'unidadeOrigem'
    const unidadeDestino = 'unidadeDestino'
    this.props.setField(name, event)

    const configFormasPagamento = utils.getConfiguracaoFormasPagamento(this.props.currentCompany, event)
    const values = utils.getFormasPagamento(enums.FormasPagamentoBasica, configFormasPagamento)
    const key = name === unidadeOrigem ? 'formasPagamentoOrigem' : 'formasPagamentoDestino'
    this.setState({ [key]: values })

    if (!this.props.record.unidadeDestino && name === unidadeOrigem) {
      this.props.setField(unidadeDestino, event)
      this.setState({ formasPagamentoDestino: values })
    }
  }

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={getMessage(this.props.messages, 'transferenciaentrecontas.label.titulo')}
      />
    )
  }

  render() {
    const content = (
      <div>
        <TransferenciaEntreContasForm
          currentUser={this.props.currentUser}
          messages={this.props.messages}
          changeHandler={this.props.changeHandler}
          record={this.props.record}
          disableUnit={this.props.disableUnit}
          unidades={this.props.unidades}
          getFiltrosPesquisaLocalizacao={this.getFiltrosPesquisaLocalizacao}
          onChangeTipoSepultura={this.onChangeTipoSepultura}
          onChangeUnidade={this.onChangeUnidade}
          setField={this.props.setField}
          selectedFilters={this.props.selectedFilters}
          formasPagamentoOrigem={this.state.formasPagamentoOrigem}
          formasPagamentoDestino={this.state.formasPagamentoDestino}
        />
      </div>
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferenciaEntreContasFormPageContainer)
